import { AttrField, HasManyByField, NumberField, OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import Label from '@/data/models/domain/Label'
import { TmArrayStringField } from '@/data/utils/types'

export enum EmailCampaignMessageStatus {
  Sent = 'sent',
  Failed = 'failed',
  Delivered = 'delivered',
  Rejected = 'rejected',
  Pending = 'pending',
  Opened = 'opened',
  Clicked = 'clicked',
  Unsubscribed = 'unsubscribed',
  Spam = 'spam',
}

@OrmModel(modelNames.EMAIL_CAMPAIGN_MESSAGE)
export default class EmailCampaignMessage<TEmail extends string | null = string | null> extends BaseModel {
  @StringField()
  public sendTime: string

  @AttrField()
  public fromName: string | null

  @StringField()
  public fromEmail: string

  @StringField()
  public replyToEmail: string

  @AttrField()
  public contactId: number | null

  @AttrField()
  public recipientFullName: string | null

  @AttrField()
  public recipientEmail: TEmail

  @StringField()
  public emailSubject: string

  @StringField()
  public emailContent: string

  @StringField()
  public source: unknown

  @StringField()
  public status: EmailCampaignMessageStatus

  @NumberField()
  public cost: number

  @AttrField()
  public statusReason: string | null

  @StringField()
  public initiatorId: string

  @TmArrayStringField()
  public labelIds: string[]

  @HasManyByField(Label, 'labelIds')
  public labels: Label[]
}
